/**
 * 이벤트 시스템 공유 더미 데이터
 */

// 약국 결제 유저 목록 (20명)
export const DUMMY_PHARMACY_USERS = [
  { id: 1, name: '김철수', gender: 'M', age: 28, phone: '010-1234-5678', total_payments: 12, last_payment_date: '2026-02-10' },
  { id: 2, name: '이영희', gender: 'F', age: 34, phone: '010-2345-6789', total_payments: 8, last_payment_date: '2026-02-09' },
  { id: 3, name: '박민수', gender: 'M', age: 45, phone: '010-3456-7890', total_payments: 22, last_payment_date: '2026-02-11' },
  { id: 4, name: '정수연', gender: 'F', age: 52, phone: '010-4567-8901', total_payments: 15, last_payment_date: '2026-02-08' },
  { id: 5, name: '최동현', gender: 'M', age: 31, phone: '010-5678-9012', total_payments: 5, last_payment_date: '2026-02-07' },
  { id: 6, name: '한지은', gender: 'F', age: 27, phone: '010-6789-0123', total_payments: 10, last_payment_date: '2026-02-11' },
  { id: 7, name: '오승훈', gender: 'M', age: 39, phone: '010-7890-1234', total_payments: 18, last_payment_date: '2026-02-10' },
  { id: 8, name: '윤미래', gender: 'F', age: 42, phone: '010-8901-2345', total_payments: 7, last_payment_date: '2026-02-06' },
  { id: 9, name: '장현우', gender: 'M', age: 55, phone: '010-9012-3456', total_payments: 30, last_payment_date: '2026-02-11' },
  { id: 10, name: '서예진', gender: 'F', age: 23, phone: '010-0123-4567', total_payments: 3, last_payment_date: '2026-02-05' },
  { id: 11, name: '강태호', gender: 'M', age: 36, phone: '010-1111-2222', total_payments: 14, last_payment_date: '2026-02-10' },
  { id: 12, name: '임수정', gender: 'F', age: 48, phone: '010-2222-3333', total_payments: 20, last_payment_date: '2026-02-09' },
  { id: 13, name: '조성민', gender: 'M', age: 25, phone: '010-3333-4444', total_payments: 6, last_payment_date: '2026-02-08' },
  { id: 14, name: '배수아', gender: 'F', age: 33, phone: '010-4444-5555', total_payments: 11, last_payment_date: '2026-02-07' },
  { id: 15, name: '류준혁', gender: 'M', age: 41, phone: '010-5555-6666', total_payments: 25, last_payment_date: '2026-02-11' },
  { id: 16, name: '문하늘', gender: 'F', age: 29, phone: '010-6666-7777', total_payments: 9, last_payment_date: '2026-02-10' },
  { id: 17, name: '홍길동', gender: 'M', age: 58, phone: '010-7777-8888', total_payments: 35, last_payment_date: '2026-02-09' },
  { id: 18, name: '신은비', gender: 'F', age: 37, phone: '010-8888-9999', total_payments: 16, last_payment_date: '2026-02-08' },
  { id: 19, name: '권도윤', gender: 'M', age: 22, phone: '010-9999-0000', total_payments: 2, last_payment_date: '2026-02-06' },
  { id: 20, name: '양서연', gender: 'F', age: 50, phone: '010-1010-2020', total_payments: 28, last_payment_date: '2026-02-11' },
];

// 저장된 타겟 그룹 (5개)
export const DUMMY_TARGET_GROUPS = [
  { id: 1, name: '20대 여성 고객', gender: 'F', ageRange: '20대', description: '20대 여성 타겟', createdAt: '2026-01-15', userCount: 2 },
  { id: 2, name: '40대 이상 남성', gender: 'M', ageRange: '40대', description: '40대 이상 남성 고객', createdAt: '2026-01-20', userCount: 3 },
  { id: 3, name: '전체 30대', gender: '전체', ageRange: '30대', description: '30대 전체 고객', createdAt: '2026-01-25', userCount: 4 },
  { id: 4, name: 'VIP 고객 (50대+)', gender: '전체', ageRange: '50대+', description: '50대 이상 충성 고객', createdAt: '2026-02-01', userCount: 4 },
  { id: 5, name: '전체 고객', gender: '전체', ageRange: '전체', description: '모든 고객 대상', createdAt: '2026-02-05', userCount: 20 },
];

// 포인트 지급 내역
export const DUMMY_POINT_DISTRIBUTIONS = [
  { id: 1, targetGroup: '전체 고객', amount: 1000, description: '설 맞이 감사 포인트', distributedAt: '2026-01-28', userCount: 20, status: 'COMPLETED' },
  { id: 2, targetGroup: '20대 여성 고객', amount: 2000, description: '신규 고객 환영 포인트', distributedAt: '2026-02-01', userCount: 2, status: 'COMPLETED' },
  { id: 3, targetGroup: 'VIP 고객 (50대+)', amount: 5000, description: 'VIP 특별 포인트', distributedAt: '2026-02-05', userCount: 4, status: 'COMPLETED' },
];

// 포인트 사용 로그 (20건)
export const DUMMY_POINT_USAGE = [
  { id: 1, userId: 1, userName: '김철수', gender: 'M', age: 28, usedAmount: 1000, paymentAmount: 15000, usedAt: '2026-02-11T10:30:00', status: '사용완료', description: '일반 결제 포인트 사용' },
  { id: 2, userId: 2, userName: '이영희', gender: 'F', age: 34, usedAmount: 2000, paymentAmount: 28000, usedAt: '2026-02-11T11:15:00', status: '사용완료', description: '처방약 결제 할인' },
  { id: 3, userId: 3, userName: '박민수', gender: 'M', age: 45, usedAmount: 3000, paymentAmount: 42000, usedAt: '2026-02-11T13:00:00', status: '사용완료', description: '건강식품 구매 할인' },
  { id: 4, userId: 6, userName: '한지은', gender: 'F', age: 27, usedAmount: 500, paymentAmount: 8000, usedAt: '2026-02-11T14:20:00', status: '사용완료', description: '일반의약품 결제' },
  { id: 5, userId: 9, userName: '장현우', gender: 'M', age: 55, usedAmount: 5000, paymentAmount: 65000, usedAt: '2026-02-11T15:45:00', status: '사용완료', description: '만성질환 처방약' },
  { id: 6, userId: 7, userName: '오승훈', gender: 'M', age: 39, usedAmount: 1500, paymentAmount: 22000, usedAt: '2026-02-10T09:30:00', status: '사용완료', description: '영양제 구매' },
  { id: 7, userId: 12, userName: '임수정', gender: 'F', age: 48, usedAmount: 2500, paymentAmount: 35000, usedAt: '2026-02-10T10:00:00', status: '사용완료', description: '처방약 결제' },
  { id: 8, userId: 15, userName: '류준혁', gender: 'M', age: 41, usedAmount: 1000, paymentAmount: 18000, usedAt: '2026-02-10T11:30:00', status: '사용완료', description: '감기약 구매' },
  { id: 9, userId: 4, userName: '정수연', gender: 'F', age: 52, usedAmount: 4000, paymentAmount: 55000, usedAt: '2026-02-10T14:00:00', status: '사용완료', description: '건강보조식품' },
  { id: 10, userId: 11, userName: '강태호', gender: 'M', age: 36, usedAmount: 800, paymentAmount: 12000, usedAt: '2026-02-10T16:20:00', status: '사용완료', description: '일반의약품' },
  { id: 11, userId: 16, userName: '문하늘', gender: 'F', age: 29, usedAmount: 1200, paymentAmount: 19000, usedAt: '2026-02-09T10:15:00', status: '사용완료', description: '피부과 처방약' },
  { id: 12, userId: 17, userName: '홍길동', gender: 'M', age: 58, usedAmount: 3500, paymentAmount: 48000, usedAt: '2026-02-09T11:45:00', status: '사용완료', description: '만성질환 약' },
  { id: 13, userId: 14, userName: '배수아', gender: 'F', age: 33, usedAmount: 1800, paymentAmount: 25000, usedAt: '2026-02-09T13:30:00', status: '사용완료', description: '영양제 결제' },
  { id: 14, userId: 5, userName: '최동현', gender: 'M', age: 31, usedAmount: 600, paymentAmount: 9500, usedAt: '2026-02-09T15:00:00', status: '취소', description: '결제 취소 처리' },
  { id: 15, userId: 20, userName: '양서연', gender: 'F', age: 50, usedAmount: 2800, paymentAmount: 38000, usedAt: '2026-02-08T09:00:00', status: '사용완료', description: '종합비타민 구매' },
  { id: 16, userId: 8, userName: '윤미래', gender: 'F', age: 42, usedAmount: 1500, paymentAmount: 21000, usedAt: '2026-02-08T11:00:00', status: '사용완료', description: '처방약 할인' },
  { id: 17, userId: 13, userName: '조성민', gender: 'M', age: 25, usedAmount: 700, paymentAmount: 10500, usedAt: '2026-02-08T14:30:00', status: '사용완료', description: '두통약 구매' },
  { id: 18, userId: 18, userName: '신은비', gender: 'F', age: 37, usedAmount: 2200, paymentAmount: 32000, usedAt: '2026-02-07T10:00:00', status: '사용완료', description: '건강식품 결제' },
  { id: 19, userId: 10, userName: '서예진', gender: 'F', age: 23, usedAmount: 400, paymentAmount: 6500, usedAt: '2026-02-07T13:00:00', status: '사용완료', description: '밴드 구매' },
  { id: 20, userId: 19, userName: '권도윤', gender: 'M', age: 22, usedAmount: 300, paymentAmount: 5000, usedAt: '2026-02-07T15:30:00', status: '사용완료', description: '소화제 구매' },
];

// 쿠폰 지급 내역
export const DUMMY_COUPON_DISTRIBUTIONS = [
  { id: 1, targetGroup: '전체 고객', couponType: 'DISCOUNT', discountType: 'FIXED', amount: 3000, description: '설 맞이 할인 쿠폰', distributedAt: '2026-01-28', userCount: 20, status: 'COMPLETED' },
  { id: 2, targetGroup: '20대 여성 고객', couponType: 'POINT', discountType: 'FIXED', amount: 2000, description: '신규 고객 적립 쿠폰', distributedAt: '2026-02-01', userCount: 2, status: 'COMPLETED' },
  { id: 3, targetGroup: 'VIP 고객 (50대+)', couponType: 'DISCOUNT', discountType: 'PERCENT', amount: 10, description: 'VIP 10% 할인', distributedAt: '2026-02-05', userCount: 4, status: 'COMPLETED' },
];

// 쿠폰 사용 로그 (20건)
export const DUMMY_COUPON_USAGE = [
  { id: 1, userId: 1, userName: '김철수', gender: 'M', age: 28, couponType: '할인', discountAmount: 3000, paymentAmount: 15000, usedAt: '2026-02-11T10:00:00', status: '사용완료', description: '설 맞이 할인 쿠폰' },
  { id: 2, userId: 3, userName: '박민수', gender: 'M', age: 45, couponType: '할인', discountAmount: 3000, paymentAmount: 42000, usedAt: '2026-02-11T11:30:00', status: '사용완료', description: '설 맞이 할인 쿠폰' },
  { id: 3, userId: 6, userName: '한지은', gender: 'F', age: 27, couponType: '적립', discountAmount: 2000, paymentAmount: 8000, usedAt: '2026-02-11T13:15:00', status: '사용완료', description: '신규 고객 적립 쿠폰' },
  { id: 4, userId: 9, userName: '장현우', gender: 'M', age: 55, couponType: '할인(10%)', discountAmount: 6500, paymentAmount: 65000, usedAt: '2026-02-11T14:45:00', status: '사용완료', description: 'VIP 10% 할인' },
  { id: 5, userId: 2, userName: '이영희', gender: 'F', age: 34, couponType: '할인', discountAmount: 3000, paymentAmount: 28000, usedAt: '2026-02-11T16:00:00', status: '사용완료', description: '설 맞이 할인 쿠폰' },
  { id: 6, userId: 7, userName: '오승훈', gender: 'M', age: 39, couponType: '할인', discountAmount: 3000, paymentAmount: 22000, usedAt: '2026-02-10T09:20:00', status: '사용완료', description: '설 맞이 할인 쿠폰' },
  { id: 7, userId: 12, userName: '임수정', gender: 'F', age: 48, couponType: '할인', discountAmount: 3000, paymentAmount: 35000, usedAt: '2026-02-10T10:45:00', status: '사용완료', description: '설 맞이 할인 쿠폰' },
  { id: 8, userId: 4, userName: '정수연', gender: 'F', age: 52, couponType: '할인(10%)', discountAmount: 5500, paymentAmount: 55000, usedAt: '2026-02-10T12:00:00', status: '사용완료', description: 'VIP 10% 할인' },
  { id: 9, userId: 15, userName: '류준혁', gender: 'M', age: 41, couponType: '할인', discountAmount: 3000, paymentAmount: 18000, usedAt: '2026-02-10T14:30:00', status: '사용완료', description: '설 맞이 할인 쿠폰' },
  { id: 10, userId: 11, userName: '강태호', gender: 'M', age: 36, couponType: '할인', discountAmount: 3000, paymentAmount: 12000, usedAt: '2026-02-10T16:15:00', status: '사용완료', description: '설 맞이 할인 쿠폰' },
  { id: 11, userId: 16, userName: '문하늘', gender: 'F', age: 29, couponType: '적립', discountAmount: 2000, paymentAmount: 19000, usedAt: '2026-02-09T10:30:00', status: '사용완료', description: '신규 고객 적립 쿠폰' },
  { id: 12, userId: 17, userName: '홍길동', gender: 'M', age: 58, couponType: '할인(10%)', discountAmount: 4800, paymentAmount: 48000, usedAt: '2026-02-09T11:00:00', status: '사용완료', description: 'VIP 10% 할인' },
  { id: 13, userId: 14, userName: '배수아', gender: 'F', age: 33, couponType: '할인', discountAmount: 3000, paymentAmount: 25000, usedAt: '2026-02-09T13:45:00', status: '사용완료', description: '설 맞이 할인 쿠폰' },
  { id: 14, userId: 5, userName: '최동현', gender: 'M', age: 31, couponType: '할인', discountAmount: 3000, paymentAmount: 9500, usedAt: '2026-02-09T15:20:00', status: '취소', description: '결제 취소' },
  { id: 15, userId: 20, userName: '양서연', gender: 'F', age: 50, couponType: '할인(10%)', discountAmount: 3800, paymentAmount: 38000, usedAt: '2026-02-08T09:15:00', status: '사용완료', description: 'VIP 10% 할인' },
  { id: 16, userId: 8, userName: '윤미래', gender: 'F', age: 42, couponType: '할인', discountAmount: 3000, paymentAmount: 21000, usedAt: '2026-02-08T11:30:00', status: '사용완료', description: '설 맞이 할인 쿠폰' },
  { id: 17, userId: 18, userName: '신은비', gender: 'F', age: 37, couponType: '할인', discountAmount: 3000, paymentAmount: 32000, usedAt: '2026-02-08T14:00:00', status: '사용완료', description: '설 맞이 할인 쿠폰' },
  { id: 18, userId: 13, userName: '조성민', gender: 'M', age: 25, couponType: '할인', discountAmount: 3000, paymentAmount: 10500, usedAt: '2026-02-07T10:30:00', status: '사용완료', description: '설 맞이 할인 쿠폰' },
  { id: 19, userId: 10, userName: '서예진', gender: 'F', age: 23, couponType: '적립', discountAmount: 2000, paymentAmount: 6500, usedAt: '2026-02-07T13:15:00', status: '사용완료', description: '신규 고객 적립 쿠폰' },
  { id: 20, userId: 19, userName: '권도윤', gender: 'M', age: 22, couponType: '할인', discountAmount: 3000, paymentAmount: 5000, usedAt: '2026-02-07T15:45:00', status: '사용완료', description: '설 맞이 할인 쿠폰' },
];

// 약국 재고 상품 (더미)
export const DUMMY_PRODUCTS = [
  { id: 'p1', name: '종근당 비타민D 2000IU', category: '비타민', company: '종근당', price: 15000, stock: 120 },
  { id: 'p2', name: '유한양행 오메가3 플러스', category: '오메가3', company: '유한양행', price: 28000, stock: 85 },
  { id: 'p3', name: '대웅제약 프로바이오틱스', category: '유산균', company: '대웅제약', price: 32000, stock: 60 },
  { id: 'p4', name: '동아제약 루테인 골드', category: '눈건강', company: '동아제약', price: 22000, stock: 45 },
  { id: 'p5', name: '일동제약 콜라겐 파우더', category: '콜라겐', company: '일동제약', price: 35000, stock: 30 },
  { id: 'p6', name: 'JW중외 칼슘마그네슘D', category: '칼슘', company: 'JW중외제약', price: 18000, stock: 95 },
  { id: 'p7', name: '한미약품 밀크씨슬', category: '간건강', company: '한미약품', price: 25000, stock: 70 },
  { id: 'p8', name: '녹십자 홍삼정 에브리타임', category: '홍삼', company: '녹십자', price: 45000, stock: 40 },
];

// 건강 관심사
export const HEALTH_INTERESTS = [
  '고혈압', '당뇨', '고지혈증', '관절염', '소화기질환',
  '호흡기질환', '피부질환', '안과질환', '비만', '면역력',
];

// 주민등록번호에서 성별 추출 (1,3=남, 2,4=여)
export const getGenderFromResident = (residentNumber) => {
  if (!residentNumber) return null;
  const cleaned = residentNumber.replace(/-/g, '');
  if (cleaned.length < 7) return null;
  const genderDigit = cleaned[6];
  if (genderDigit === '1' || genderDigit === '3') return 'M';
  if (genderDigit === '2' || genderDigit === '4') return 'F';
  return null;
};

// 주민등록번호에서 나이 계산
export const getAgeFromResident = (residentNumber) => {
  if (!residentNumber) return null;
  const cleaned = residentNumber.replace(/-/g, '');
  if (cleaned.length < 7) return null;

  const yymmdd = cleaned.substring(0, 6);
  const genderDigit = cleaned[6];

  const yy = parseInt(yymmdd.substring(0, 2), 10);
  const mm = parseInt(yymmdd.substring(2, 4), 10);
  const dd = parseInt(yymmdd.substring(4, 6), 10);

  // 1,2 → 1900년대 / 3,4 → 2000년대
  const century = (genderDigit === '3' || genderDigit === '4') ? 2000 : 1900;
  const birthYear = century + yy;

  const now = new Date();
  let age = now.getFullYear() - birthYear;
  const birthDate = new Date(birthYear, mm - 1, dd);
  if (now < new Date(now.getFullYear(), birthDate.getMonth(), birthDate.getDate())) {
    age--;
  }
  return age;
};

// 유저의 성별 가져오기 (resident_number 우선, gender 필드 fallback)
export const getUserGender = (user) => {
  if (user.resident_number) return getGenderFromResident(user.resident_number);
  return user.gender || null;
};

// 유저의 나이 가져오기 (resident_number 우선, age 필드 fallback)
export const getUserAge = (user) => {
  if (user.resident_number) return getAgeFromResident(user.resident_number);
  return user.age || null;
};

// 연령대 필터 헬퍼
export const getAgeRange = (age) => {
  if (age == null) return null;
  if (age < 30) return '20대';
  if (age < 40) return '30대';
  if (age < 50) return '40대';
  return '50대+';
};

// 연령대 필터링 함수
export const filterByAgeRange = (users, ageRange) => {
  if (!ageRange || ageRange === '전체') return users;
  return users.filter(u => {
    const age = getUserAge(u);
    if (age == null) return false;
    switch (ageRange) {
      case '20대': return age >= 20 && age < 30;
      case '30대': return age >= 30 && age < 40;
      case '40대': return age >= 40 && age < 50;
      case '50대+': return age >= 50;
      default: return true;
    }
  });
};

// 성별 필터링 함수
export const filterByGender = (users, gender) => {
  if (!gender || gender === '전체') return users;
  return users.filter(u => getUserGender(u) === gender);
};

// 금액 포맷
export const formatAmount = (amount) => {
  return amount.toLocaleString('ko-KR');
};

// 날짜 포맷
export const formatDateTime = (dateStr) => {
  const d = new Date(dateStr);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};
